import type IExercise from '../../../models/pa-egna-ben/exercise.model';
// import type { ExerciseLevel } from '../../../models/pa-egna-ben/exercise-level.enum';
import ExerciseHelper from '../helpers/exercises.helper';

export default class ExerciseApiModel {
  id!: string;
  name!: string;
  level!: string;
  url!: string;

  public static mapToBusinessModel(apiModel: ExerciseApiModel): IExercise {
    return {
      id: apiModel.id,
      name: apiModel.name,
      level: ExerciseHelper.parseExerciseLevel(apiModel.level),
      url: apiModel.url,
    };
  }
}

